var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('course-institute',{attrs:{"course":_vm.course}}),_c('course-date',{attrs:{"course":_vm.course}}),_c('course-enroll-count',{attrs:{"course":_vm.course}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }